module.exports = __webpack_public_path__ + "static/media/close.46b07b39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/TabView/close.svg
// module id = 1423
// module chunks = 2